<template>
  <div class="border-thin rounded-t-lg bg-grey-darken-2 text-white text-h5 pa-2">{{ title }}</div>
  <VueSignaturePad
    ref="signaturePad"
    height="400px"
    width="100%"
    :max-width="signatureOptions.maxWidth"
    :min-width="signatureOptions.minWidth"
    :options="{
      penColor: signatureOptions.penColor,
      backgroundColor: signatureOptions.backgroundColor,
    }"
    @endStroke="validate" />
  <div v-if="!isSubmitted">
    <v-btn
      type="button"
      block
      class="bg-grey-darken-2 text-white pa-2 rounded-b-lg text-white"
      @click="handleClearCanvas()">
      Clear
    </v-btn>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import { VueSignaturePad } from '@selemondev/vue3-signature-pad';

interface Props {
  isSubmitted: boolean;
  title: string;
}
const props = defineProps<Props>();
const isSubmitted = computed(() => props.isSubmitted);
const title = computed(() => props.title);
const emit = defineEmits(['validateSignature']);
const signatureOptions = ref({
  penColor: 'rgb(0,0,0)',
  backgroundColor: 'rgb(255, 255, 255)',
  maxWidth: 2,
  minWidth: 2,
});
const signaturePad = ref<InstanceType<typeof VueSignaturePad>>();

function handleClearCanvas(): void {
  signaturePad.value?.clearCanvas();
  validate();
  return;
}

const validate = () => {
  let isValid = true;
  if (!signaturePad.value || signaturePad.value?.isCanvasEmpty()) {
    isValid = false;
  }
  emit('validateSignature', isValid);
  return isValid;
};
</script>
